export default __webpack_public_path__ + "static/media/Driver.70a816ba.png";